var t=function(){return"ontouchstart"in window?"touchstart":"click"};export{t as default};
//# sourceMappingURL=clickEvent.mjs.map
